import { loadOptions } from "../browser.mjs";
export { loadOptions };
